// BRAND config — single file for easy renaming.
const BRAND = {
  name: 'Yulo Coach',
  shortName: 'Yulo',
  tagline: 'Practice before it matters',
  description: 'Your private dating confidence coach. Practice conversations, polish your profile, and walk into real dates ready.',
  accent: '#E06E53',
  accentHover: '#C95A41',
  bg: '#FDFBF7',
  supportEmail: 'info@yuloapp.com',
  domain: 'yuloapp.com',
  trialPrice: '₹99',
  monthlyPrice: '₹799',
  quarterlyPrice: '₹1,999',
};

export default BRAND;
